function keywordSignature(keywords = []) {
  return [...new Set((Array.isArray(keywords) ? keywords : [])
    .map((item) => String(item || '').trim())
    .filter(Boolean))]
    .map((keyword) => keyword.toLowerCase())
    .join('|');
}

export function createSearchTermsSyncController({
  getState,
  setState,
  updateSearchTerms,
  normalizeSearchTermsDraft,
  warn = (...args) => console.warn(...args),
  timers = globalThis,
} = {}) {
  let timer = null;
  let inFlight = null;
  let queued = false;

  function getJobId() {
    return getState('asinSnapshotJobId') || getState('snapshotJobId') || '';
  }

  function clear() {
    if (timer === null) return;
    timers.clearTimeout(timer);
    timer = null;
  }

  function schedule() {
    if (!getJobId()) return;
    clear();
    timer = timers.setTimeout(() => {
      timer = null;
      sync().catch((error) => {
        warn('[Step2] 同步搜索词失败:', error?.message || error);
      });
    }, 500);
  }

  async function sync() {
    const jobId = getJobId();
    if (!jobId) return null;
    if (inFlight) {
      queued = true;
      return inFlight;
    }

    const selected = [...new Set((getState('selectedStKeywords') || new Set()))];
    const signature = keywordSignature(selected);
    if (!selected.length) return null;
    const lastSynced = getState('step02SearchTermsSelectionDraft')?.__syncedSelectionSignature || '';
    if (signature && signature === lastSynced) return null;

    inFlight = (async () => {
      const response = await updateSearchTerms(jobId, { selected });
      const normalized = normalizeSearchTermsDraft(response?.listing?.searchTerms || {});
      if (normalized) {
        normalized.__syncedSelectionSignature = keywordSignature(normalized.selected);
        setState('step02SearchTermsSelectionDraft', normalized);
        setState('selectedStKeywords', new Set(normalized.selected || []));
      }
      return response;
    })();

    try {
      return await inFlight;
    } finally {
      inFlight = null;
      if (queued) {
        queued = false;
        schedule();
      }
    }
  }

  return { clear, schedule, sync };
}
